type TasksCalendarVisibilityFiltersProps = {
  showCompleted: boolean;
  showCancelled: boolean;
  onShowCompletedChange: (value: boolean) => void;
  onShowCancelledChange: (value: boolean) => void;
  disabled?: boolean;
  className?: string;
};

export function TasksCalendarVisibilityFilters({
  showCompleted,
  showCancelled,
  onShowCompletedChange,
  onShowCancelledChange,
  disabled = false,
  className,
}: TasksCalendarVisibilityFiltersProps) {
  return (
    <div className={className ?? 'space-y-1'}>
      <label className="flex items-center gap-2 text-xs text-slate-600">
        <input
          type="checkbox"
          checked={showCompleted}
          disabled={disabled}
          onChange={(event) => onShowCompletedChange(event.target.checked)}
          className="rounded border-slate-300"
        />
        <span>Exibir concluídas</span>
      </label>
      <label className="flex items-center gap-2 text-xs text-slate-600">
        <input
          type="checkbox"
          checked={showCancelled}
          disabled={disabled}
          onChange={(event) => onShowCancelledChange(event.target.checked)}
          className="rounded border-slate-300"
        />
        <span>Exibir canceladas</span>
      </label>
    </div>
  );
}
